import React from 'react';
import MainBody from '../templates/MainBody';
import { darkintContent } from '../data';

//ransomeware dark web, leak forums, paste sites, onion sites, monitoring tools
//dark web marketplaces, how to access, tor, tails, vpn, whonix 

const DARKINT: React.FC = () => {
  return <MainBody data={darkintContent} />;
};

export default DARKINT;